// Recovered compiled webpack factory 7460. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "matchSegment", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
  let r = (e, t) =>
    "string" == typeof e
      ? "string" == typeof t && e === t
      : "string" != typeof t && e[0] === t[0] && e[1] === t[1];
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
